
/* injects from baggage-loader */

'use strict';

import bg1 from '_images/tutorial/01.png';
import bg2 from '_images/tutorial/02.png';

export default class DialogTutorialController {
    constructor($log, $rootScope) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        
        this.step = 0;

        this.steps = [
          {
            bg: bg1,
            text: '<b>Olá!</b> Para se tornar um chef, a <br> primeira coisa que você <br> precisa aprender é sobre <br> cardápios. Você sabe para que <br> serve um cardápio?'
          },
          {
            bg: bg1,
            text: 'Em um restaurante, o <br> <b>cardápio</b> serve para ajudar <br> o cliente a escolher o que quer <b>comer</b> ou <b>beber.</b>'
          },
          {
            bg: bg2,
            text: 'Em muitos lugares, o cardápio <br> é dividido em seções, como <b>entrada, prato principal, sobremesa e bebidas.</b>'
          }
        ];
    }

    toNext(){
      return this.step === 2 ? this.ok() : this.step++;
    }

    ok(){
      this.modalInstance.close(true);
    }

    cancel(){
      this.modalInstance.dismiss('cancel');
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/tutorial/tutorial.controller.js